import { render, staticRenderFns } from "./permissionManager.vue?vue&type=template&id=78afe8a7&scoped=true&"
import script from "./permissionManager.vue?vue&type=script&lang=js&"
export * from "./permissionManager.vue?vue&type=script&lang=js&"
import style0 from "./permissionManager.vue?vue&type=style&index=0&id=78afe8a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78afe8a7",
  null
  
)

export default component.exports